/* Adventure Life: color swatch dropdown (enhances Color/Pattern selects on product pages)
   Swatch images come from Content > Files named after the color handle, e.g. red.png, gold-metallic.png.
   The native <select> stays in the page (hidden) and drives price, variant and add to cart. */
(function () {
  var BASE = 'https://cdn.shopify.com/s/files/1/0555/6974/4041/files/';
  var ALIAS = {
    'black': 'gloss-black',
    'white': 'gloss-white',
    'american-flag': 'red-white-and-blue',
    'black-and-grey-flag': 'black-and-grey',
    'black-and-white-flag': 'black-and-white'
  };

  var css = '' +
    '.al-sw-fieldset{flex:1 1 100%!important;width:100%!important;max-width:100%!important;min-width:0!important}' +
    '.al-sw-wrap{position:relative;width:100%}' +
    '.al-sw-wrap>:not(.al-sw-btn):not(.al-sw-list):not(select){display:none!important}' +
    '.al-sw-native{position:absolute!important;opacity:0!important;pointer-events:none!important;width:1px!important;height:1px!important;overflow:hidden!important}' +
    '.al-sw-btn{display:flex;align-items:center;gap:10px;width:100%;min-height:44px;padding:8px 12px;border:1px solid rgba(0,0,0,.25);border-radius:4px;background:#fff;color:inherit;font:inherit;text-align:left;cursor:pointer}' +
    '.al-sw-label{flex:1;min-width:0;white-space:normal;overflow-wrap:anywhere;line-height:1.25}' +
    '.al-sw-caret{font-size:12px;opacity:.7;flex:0 0 auto}' +
    '.al-sw-chip{width:24px;height:24px;flex:0 0 24px;border-radius:50%;overflow:hidden;background:#e9e9e9;border:1px solid rgba(0,0,0,.18)}' +
    '.al-sw-chip img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.al-sw-list{position:absolute;z-index:40;left:0;right:0;min-width:240px;top:calc(100% + 4px);max-height:340px;overflow-y:auto;margin:0;padding:4px 0;list-style:none;background:#fff;border:1px solid rgba(0,0,0,.2);border-radius:4px;box-shadow:0 8px 24px rgba(0,0,0,.15)}' +
    '.al-sw-opt{display:flex;align-items:center;gap:10px;padding:8px 12px;min-height:40px;cursor:pointer;color:#000;line-height:1.25}' +
    '.al-sw-opt span:last-child{white-space:normal;overflow-wrap:anywhere}' +
    '.al-sw-opt:hover,.al-sw-opt:focus{background:#f4f4f4;outline:none}' +
    '.al-sw-opt[aria-selected="true"]{font-weight:600}' +
    '.al-sw-opt.is-disabled{opacity:.45}' +
    '@media (max-width:768px){.al-sw-list{max-height:55vh}}';

  function injectCss() {
    if (document.getElementById('al-sw-css')) return;
    var s = document.createElement('style');
    s.id = 'al-sw-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function handle(v) {
    return String(v).toLowerCase().replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function src(v) {
    var h = handle(v);
    return BASE + (ALIAS[h] || h) + '.png?width=64';
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function chip(v) {
    return '<span class="al-sw-chip"><img src="' + src(v) + '" alt="" loading="lazy" onerror="this.remove()"></span>';
  }

  function isColorSelect(sel) {
    return /colou?r|pattern/i.test(sel.getAttribute('data-option-name') || '');
  }

  function build(sel) {
    if (sel.getAttribute('data-al-swatch') === '1') return;
    sel.setAttribute('data-al-swatch', '1');

    var wrap = sel.closest('.kit-select') || sel.parentElement;
    var fieldset = sel.closest('fieldset');
    if (fieldset) fieldset.classList.add('al-sw-fieldset');
    var old = wrap.querySelectorAll('.al-sw-btn, .al-sw-list');
    for (var k = 0; k < old.length; k++) old[k].remove();
    wrap.classList.add('al-sw-wrap');
    sel.classList.add('al-sw-native');

    var label = sel.getAttribute('data-option-name') || 'Color';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'al-sw-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', label);

    var list = document.createElement('ul');
    list.className = 'al-sw-list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', label);
    list.hidden = true;

    function render() {
      var o = sel.options[sel.selectedIndex];
      if (!o) return;
      btn.innerHTML = chip(o.value) + '<span class="al-sw-label">' + esc(o.text) + '</span><span class="al-sw-caret" aria-hidden="true">&#9662;</span>';
      var items = list.children;
      for (var i = 0; i < items.length; i++) {
        items[i].setAttribute('aria-selected', items[i].getAttribute('data-value') === sel.value ? 'true' : 'false');
        var opt = sel.querySelector('option[value="' + CSS.escape(items[i].getAttribute('data-value')) + '"]');
        items[i].classList.toggle('is-disabled', !!(opt && opt.disabled));
      }
    }

    function close() {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }

    function open() {
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var cur = list.querySelector('[aria-selected="true"]') || list.firstChild;
      if (cur) { cur.focus(); cur.scrollIntoView({ block: 'nearest' }); }
    }

    function choose(v) {
      sel.value = v;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      close();
      render();
      btn.focus();
    }

    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      if (!o.value) continue;
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.className = 'al-sw-opt';
      li.setAttribute('data-value', o.value);
      li.innerHTML = chip(o.value) + '<span>' + esc(o.text) + '</span>';
      li.addEventListener('click', (function (v) { return function () { choose(v); }; })(o.value));
      list.appendChild(li);
    }

    btn.addEventListener('click', function () { list.hidden ? open() : close(); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); }
    });
    list.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(list.children);
      var idx = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(idx + 1, items.length - 1)].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(idx - 1, 0)].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (document.activeElement && document.activeElement.click) document.activeElement.click(); }
      else if (e.key === 'Escape' || e.key === 'Tab') { close(); btn.focus(); }
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    sel.addEventListener('change', render);

    wrap.appendChild(btn);
    wrap.appendChild(list);
    render();
  }

  function scan() {
    var sels = document.querySelectorAll('select.kit-select__native');
    for (var i = 0; i < sels.length; i++) {
      if (isColorSelect(sels[i])) build(sels[i]);
    }
  }

  function init() {
    injectCss();
    scan();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; scan(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
